import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../reportingHelpers";
import { countShootoutGoalsByTeam } from "./helpers.js";

const scoringCellStyle = {
  flexDirection: "row",
  border: borderStyleGray,
  borderTop: "unset",
};

const teamNameStyle = {
  fontWeight: "bold",
  border: borderStyleGray,
  flexBasis: "35%",
  alignItems: "center",
  justifyContent: "center",
  height: 40,
};

const ScoringRow = ({ label, value }) => (
  <View style={scoringCellStyle}>
    <View style={{ borderRight: borderStyleGray, width: "50%" }}>
      <Text style={{ textAlign: "center" }}>{label}</Text>
    </View>
    <View style={{ width: "50%" }}>
      <Text style={{ fontWeight: "bold", textAlign: "center" }}>{value}</Text>
    </View>
  </View>
);

const TeamsAndScores = ({ intl, scoringIntervals, teams, playByPlay = undefined, showShootout = false}) => {
  const homeTeamName = Object.values(teams).find((team) => team.isHome).name;
  const awayTeamName = Object.values(teams).find((team) => !team.isHome).name;
  const homeTeamId = Object.keys(teams).find((id) => teams[id].isHome);
  const awayTeamId = Object.keys(teams).find((id) => !teams[id].isHome);
  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        marginTop: 6,
        fontSize: 12,
        alignItems: "center",
      }}
    >
      <View style={teamNameStyle}>
        <Text>{homeTeamName}</Text>
      </View>
      <View
        style={{ flexBasis: "25%", fontSize: 10, borderTop: borderStyleGray }}
      >
        <ScoringRow
          label={intl.formatMessage({
            id: "reports.matchReport.fullTime",
            defaultMessage: "Full Time",
          })}
          value={scoringIntervals[3]}
        />
        <ScoringRow
          label={intl.formatMessage({
            id: "reports.matchReport.thirdPeriod",
            defaultMessage: "Third Period",
          })}
          value={scoringIntervals[2]}
        />
        <ScoringRow
          label={intl.formatMessage({
            id: "reports.matchReport.halfTime",
            defaultMessage: "Half Time",
          })}
          value={scoringIntervals[1]}
        />
        <ScoringRow
          label={intl.formatMessage({
            id: "reports.matchReport.firstPeriod",
            defaultMessage: "First Period",
          })}
          value={scoringIntervals[0]}
        />
        {showShootout && <ScoringRow
          label={intl.formatMessage({
            id: "reports.shootout",
            defaultMessage: "Shootout",
          })}
          value={`${countShootoutGoalsByTeam(playByPlay, homeTeamId)} - ${countShootoutGoalsByTeam(playByPlay, awayTeamId)}`}
        />}
      </View>
      <View style={teamNameStyle}>
        <Text>{awayTeamName}</Text>
      </View>
    </View>
  );
};

export default TeamsAndScores;
